import { useQuery } from '@tanstack/react-query';
import { useMedplum } from '@medplum/react';

import { CUSTOM_IDENTIFIER_SYSTEMS } from '@/features/shared/constants/fhir-systems';

import { useLogger } from './useLogger';

export const botQueryKey = (identifierValue: string) => ['bot', identifierValue];

export function useBot(identifierValue: string) {
	const logger = useLogger();
	const medplum = useMedplum();

	return useQuery({
		queryKey: botQueryKey(identifierValue),
		queryFn: async () => {
			const bot = await medplum.searchOne('Bot', {
				identifier: `${CUSTOM_IDENTIFIER_SYSTEMS.BOT_IDENTIFIER}|${identifierValue}`,
			});

			if (!bot) {
				logger.warn(`Bot with identifier ${identifierValue} not found`);
				return null;
			}

			return bot;
		},
		staleTime: Number.POSITIVE_INFINITY,
	});
}
